import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from './LayerShortSettingStyle';


const LayerShortSettingHeader2: React.FC = () => {
  const { t } = useTranslation();
  const classes = TableBaseStyle();

  return (
    <TableRow>
      <TableCell className={classes.tableHeader} width={200}>{t('LayerShortSettingHeader2.閾値', '閾値(割合)')}</TableCell>
      <TableCell className={classes.tableHeader} width={100}>{t('LayerShortSettingHeader2.R相', 'R相')}</TableCell>
      <TableCell className={classes.tableHeader} width={100}>{t('LayerShortSettingHeader2.S相', 'S相')}</TableCell>
      <TableCell className={classes.tableHeader} width={100}>{t('LayerShortSettingHeader2.T相', 'T相')}</TableCell>
    </TableRow>
  )
};

export default LayerShortSettingHeader2;